<template>
    <div class="modal fade modal-mediaGallery" id="mediaGallery" tabindex="-1" aria-labelledby="mediaGalleryModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Media</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="!upload">
                    <div class="row mb-2">
                        <div class="col-md-6 mb-2">
                            <button type="button" class="btn btn-primary btn-block bg-orange btn-icon remove-border" @click="upload = !upload"><i class="icon icon-add_circle"></i> Tambah Image</button>
                        </div>
                        <div class="col-md-6">
                            <div class="search-form">
                                <div class="form-group search-form-wrap">
                                    <i class="icon icon-search"></i>
                                    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Cari" v-model="search">
                                </div>
                                <div>
                                    <button class="btn btn-secondary btn-block" @click="handleSearch">Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!loading">
                        <div class="list-gallery row">
                            <div class="col-6" v-for="item in galleries.data" @click="selectMedia(item)">
                                <div class="media-gallery-card pointer">
                                    <div class="media-gallery-img">
                                        <img :src="item.file[0].orifullpath">
                                    </div>
                                    <div class="media-gallery-desc">
                                        <div class="media-gallery-title">{{ item.judul }}</div>
                                        <div class="media-gallery-desc-desc">{{ item.captionphoto }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="mx-auto">
                                <pagination :data="galleries" @pagination-change-page="getData" :limit="1"></pagination>
                            </div>
                        </div>
                    </div>
                    <div class="text-center" v-else>
                        <pulse-loader color="#EC550E"></pulse-loader>
                    </div>
                </div>
                <div class="modal-body" v-if="upload">
                    <div v-if="!uploading">
                        <div class="form-group pointer" v-if="!imgSrc || crop">
                            <label>Image</label>
                            <div class="upload-image" v-bind:class="errors.hasOwnProperty('media') ? 'is-invalid' : ''" @click="chooseFiles()">
                                <div class="image-example">
                                    <img :src="!crop ? '/assets/images/icons/add_image.png' : imgSrc">
                                </div>
                                <div class="upload-image-help">* Ukuran maksimal 2 MB <br>
                                    * Dimensi tidak kurang dari 500x500 pixels<br>
                                    * Format JPG atau PNG</div>
                            </div>
                            <button class="btn btn-primary mt-1" @click="chooseFiles()" v-if="imgSrc || !crop">
                                Change Image
                            </button>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('media')">
                                {{ errors['media'][0] }}
                            </div>
                        </div>
                        <div v-else>
                            <div>
                                <vue-cropper
                                    ref="cropper"
                                    :aspect-ratio="16 / 9"
                                    :src="imgSrc"
                                    preview=".preview"
                                    :zoomable="false"
                                />
                            </div>
                            <div class="mt-1 mb-2 text-center">
                                <button class="btn btn-primary" @click="chooseFiles()">
                                    Change Image
                                </button>
                                <button class="btn btn-primary" @click.prevent="cropImage">
                                    Crop
                                </button>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="judul">Judul</label>
                            <input type="email" class="form-control clean-form" id="judul" v-bind:class="errors.hasOwnProperty('judul') ? 'is-invalid' : ''" v-model="form.judul">
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('judul')">
                                {{ errors['judul'][0] }}
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="deskripsi">Deskripsi</label>
                            <textarea class="form-control clean-form" id="deskripsi" rows="3" v-bind:class="errors.hasOwnProperty('captionphoto') ? 'is-invalid' : ''" v-model="form.captionphoto"></textarea>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('captionphoto')">
                                {{ errors['captionphoto'][0] }}
                            </div>
                        </div>
                        <div class="button-wrap">
                            <button type="submit" class="btn btn-primary main-button pill-button bg-orange" @click="handleSubmit">Simpan</button>
                            <button type="submit" class="btn btn-primary main-button pill-button bg-grey" @click="upload = !upload">Batal</button>
                        </div>
                        <input id="fileUpload" type="file" @change="setImage" accept="image/png, image/jpeg" hidden>
                    </div>
                    <div class="text-center" v-else>
                        <pulse-loader color="#EC550E"></pulse-loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.modal {
    z-index: 2000;
}
.modal-mediaGallery .modal-dialog {
    max-width: 95%;
}
.modal-mediaGallery .modal-content {
    background-color: #EAECF0;
    border-radius: 15px;
    border: none;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.25)
}
.media-gallery-card {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    margin-right: 0;
    margin-left: 0;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    text-align: center;
}
.media-gallery-img img {
    width: 100%;
    height: 150px;
    object-fit: cover;
}
.media-gallery-title {
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 18px;
    color: #333333;
}
.media-gallery-desc-desc {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: #4F4F4F;
}
.media-gallery-card .col-6 {
    padding-right: 5px;
    padding-left: 5px;
}
.search-form {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.search-form .form-group {
    margin-bottom: 0;
    width: 100%;
}
.search-form-wrap i {
    position: absolute;
    top: 6px;
    left: 24px;
    width: 16px;
}
.search-form-wrap .form-control {
    text-indent: 24px;
}

.search-form-wrap .form-control::-webkit-input-placeholder {
    font-size: 12px;
    line-height: 18px;
}
.list-gallery {
    margin: 15px 0;
}
.form-group {
    text-align: center;
}
.upload-image {
    padding: 30px;
    border: 1px solid #eee;
    border-radius: 12px;
}
.image-example img {
    width: 100%;
    border-radius: 12px;
}
.upload-image-help {
    color: #828282;
    font-size: 10px;
    line-height: 15px;
    padding: 10px 0;
    text-align: left;
}
.upload-image .upload-btn {
    background-color: #333;
    border-radius: 10px;
    color: #fff;
    border: 0;
    padding: 5px 30px;
}
.image-example .delete-btn {
    position: absolute;
    right: 8%;
    flex: 1;
    background: transparent;
    border: none;
    margin-top: -10px;
}
.media-gallery-img {
    width: 100%;
    height: 150px;
    overflow: hidden;
    border-radius: 6px;
    text-align: center;
    margin: 0;
    padding: 0;
}
.media-gallery-desc {
    margin: 0;
    padding: 0;
}
.upload-image.is-invalid {
    border: 1px solid #e3342f;
}
@media only screen and (min-width: 768px) {
    .modal-mediaGallery .modal-dialog {
        max-width: 50%;
    }
}
</style>

<script>
import $ from 'jquery';
import axios from "axios";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {DataURIToBlob} from "../UploadHandler";

export default {
    components: {
        VueCropper,
        PulseLoader
    },
    data() {
        return {
            crop: false,
            upload: false,
            imgSrc: '',
            form: {
                judul: '',
                captionphoto: '',
                media: ''
            },
            galleries: {},
            search: '',
            uploading: false,
            loading: true,
            errors: []
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData(page = 1) {
            $("#mediaGallery").scrollTop(0);
            const token = this.$cookies.get('token');
            axios.get(`/api/gallery?search=${this.search}&page=${page}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.galleries = response.data
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        handleSearch() {
            this.getData()
        },
        handleSubmit() {
            const token = this.$cookies.get('token');
            this.errors = [];
            let formData = new FormData();
            if(this.form.media) {
                const file = DataURIToBlob(this.form.media)
                formData.append('media', file);
            }
            formData.append('judul', this.form.judul);
            formData.append('captionphoto', this.form.captionphoto);
            this.uploading = true;
            axios.post('/api/gallery', formData, { headers: {"Authorization" : `Bearer ${token}`, 'Content-Type': 'multipart/form-data'} })
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    });
                    this.selectMedia(response.data.data);
                    this.getData();
                    this.uploading = false;
                })
                .catch((error) => {
                    this.uploading = false;
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors
                        }
                    }
                });
        },
        chooseFiles() {
            document.getElementById("fileUpload").click()
        },
        cropImage() {
            this.form.media = this.$refs.cropper.getCroppedCanvas({
                maxWidth: 1000,
                maxHeight: 563,
            }).toDataURL();
            this.imgSrc = this.$refs.cropper.getCroppedCanvas({
                maxWidth: 1000,
                maxHeight: 563,
            }).toDataURL();
            this.crop = true;
        },
        setImage(e) {
            const file = e.target.files[0];
            if (file.type.indexOf('image/') === -1) {
                this.$notify({
                    duration: 5000,
                    group: 'main',
                    title: 'Oopppss!',
                    text: "Please select an image file",
                    type: 'warn'
                });
                return;
            }
            if (typeof FileReader === 'function') {
                this.imgSrc = '';
                const reader = new FileReader();
                reader.onload = (event) => {
                    if(event.total > 2097152) {
                        this.errors = {
                            "media": [
                                "Size gambar melebihi 2MB"
                            ]
                        }
                        this.imgSrc = '';
                        this.form.media = '';
                        this.crop = false;
                    } else {
                        this.imgSrc = event.target.result;
                        this.crop = false;
                    }
                };
                reader.readAsDataURL(file);
            } else {
                this.$notify({
                    duration: 5000,
                    group: 'main',
                    title: 'Oopppss!',
                    text: "Sorry, FileReader API not supported",
                    type: 'warn'
                });
            }
        },
        selectMedia(media) {
            $('#mediaGallery').modal('hide')
            this.$emit('media', media)
            this.upload = false
            this.crop = false
            this.imgSrc = ''
            this.form = {
                judul: '',
                captionphoto: '',
                media: ''
            }
        }
    }
}
</script>
